/* jshint browserify: true */
'use strict';

module.exports = {
    availablelanguages: [
        'abap', 'actionscript', 'ada', 'asciidoc', 'assembly_x86', 'autohotkey',
        'batchfile', 'c9search', 'c_cpp', 'clojure', 'cobol', 'coffee', 'coldfusion',
        'csharp', 'css', 'curly', 'd', 'dart', 'diff', 'django', 'dot', 'ejs',
        'erlang', 'forth', 'fortran', 'ftl', 'glsl', 'golang', 'groovy', 'haml', 'haskell',
        'haxe', 'html', 'html_ruby', 'ini', 'jade', 'java', 'javascript', 'json',
        'jsoniq', 'jsp', 'jsx', 'julia', 'latex', 'less', 'liquid', 'lisp',
        'livescript', 'logiql', 'lsl', 'lua', 'luapage', 'lucene', 'makefile',
        'markdown', 'matlab', 'mushcode', 'mushcode_high_rules', 'mysql',
        'objectivec', 'ocaml', 'pascal', 'perl', 'pgsql', 'php', 'plain_text',
        'powershell', 'prolog', 'properties', 'python', 'r', 'rdoc', 'rhtml',
        'ruby', 'rust', 'sass', 'scad', 'scala', 'scheme', 'scss', 'sh', 'snippets',
        'sql', 'stylus', 'svg', 'swift', 'tcl', 'tex', 'text', 'textile', 'toml', 'twig',
        'typescript', 'vbscript', 'velocity', 'verilog', 'xml', 'xquery', 'yaml',
    ],

    claireConversion: {
        c: 'c_cpp',
        'html+php': 'php',
        cpp: 'c_cpp',
        nasm: 'assembly_x86',
        'objective-c': 'objectivec',
    },

    syntaxMap: {
        fortran: 'text',
    },
};
